import { DeviceHub } from '@mui/icons-material';
import { Badge, IconButton, Tooltip } from '@mui/material';
import clsx from 'clsx';
import { MapContext } from 'components/maps';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import useLayersToolbarStyles from '../styles';
import { EntityDrawerButtonProps } from './types';

export const EntityDrawerButton: React.FunctionComponent<EntityDrawerButtonProps> = () => {
  const { t } = useTranslation(['common']);
  const classes = useLayersToolbarStyles();
  const { toggleEntities, isEntitiesOpen } = useContext(MapContext);
  const { push } = useHistory();
  const { selectedEntities } = useContext(MapContext);

  return (
    <Tooltip title={t('deviceManager')}>
      <IconButton
        className={clsx(classes.button, { [classes.buttonActive]: isEntitiesOpen })}
        onClick={() => {
          toggleEntities();
          if (isEntitiesOpen) {
            push('/');
          }
        }}
        aria-label={t('deviceManager')}
      >
        <Badge badgeContent={selectedEntities.size} color='primary' variant='dot'>
          <DeviceHub fontSize='small' />
        </Badge>
      </IconButton>
    </Tooltip>
  );
};

export default EntityDrawerButton;
